import React from "react";
import { HashRouter as Router,Route,Link} from 'react-router-dom';
import rous from "../components/Model/rous";
import '../assets/css/base.css';
import '../assets/css/back.css';
import DeTime from '../components/Model/DeTime';
/** ant布局*/
import { Layout, Menu, Icon } from 'antd';
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
class Back extends React.Component{
     state={
      regionIdMd:"",
      name:"",
      collapsed: false,
      key:"1",
      flag:false
  }
      //组件将要挂载时候加载的生命周期函数
     componentDidMount(){
       if(localStorage.getItem("key")===""||localStorage.getItem("key")===undefined){
        localStorage.setItem("key",'1');
       }
        //regionIdMd 加密后regionIdMd    
    }  
      toggle = () => {
        this.setState({
          collapsed: !this.state.collapsed,
        });
      }
      onSelect =(key) =>{          
         localStorage.setItem("key",key);
      }
      render() {   
        return ( 
          <Router>
              <div>
            <Layout>
            <Sider
              trigger={null}
              collapsible
              collapsed={this.state.collapsed}
            >
              <div className="logo" />
              <Menu theme="dark" mode="inline" inlineCollapsed={this.state.collapsed}  defaultOpenKeys={['sub1']} defaultSelectedKeys={[localStorage.getItem("key")]}>
              <SubMenu
                  key="sub1"
                  title={
                    <span>
                      <Icon type="user" />
                      <span>我的村宝</span>
                    </span>
                  }
                >
                  <Menu.Item key="1">
                  <Link to={`/login/${localStorage.getItem("regionIdMd")}`} onClick={(e)=>this.onSelect('1')}> <span>村宝列表</span></Link>
                  </Menu.Item>
                  {localStorage.getItem("regionId")==="0"?"":
                   <Menu.Item key="2">
                  <Link to={`/news`} onClick={(e)=>this.onSelect('2')}><span>添加村宝</span></Link>
                 </Menu.Item>}         
            </SubMenu>
                {/*<Menu.Item key="1">
                  <Icon type="user" />
                  <span><Link to={`/login/${this.state.regionId}`}>我的村宝</Link></span>
                </Menu.Item>           
                 <Menu.Item key="2">
                  <Icon type="video-camera" />
                  <span><Link to={`/user`}>用户组件</Link></span>
                </Menu.Item>
                <Menu.Item key="3">
                  <Icon type="upload" />
                  <span><Link to={`/shop`}>商铺</Link></span>
                </Menu.Item>*/}
              </Menu>
            </Sider>
            <Layout>
              <Header style={{ background: '#fff', padding: 0 }}>
                <Icon
                  className="trigger"
                  type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />
                <div className="date"> <DeTime className="date"/></div>
              </Header>
              <Content style={{
                margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280,
              }}
              >
               {/* 内容主体 */}
               {rous.map((route, key) => {
                if (rous.exact) {
                  return (
                    <Route key ={key} exact path={route.path} 
                    /*传递嵌套路由*/                
                      render={props => (                 
                      <route.component {...props} routes={route.routes} />
                    )}
                    />
                  );
                } else {
                  return (
                    <Route key ={key} exact path={route.path} 
                      /*传递嵌套路由*/                
                      render={props => (                 
                        <route.component {...props} routes={route.routes} />
                      )}    
                     />
                  );
                }
              })}
              </Content>
            </Layout>
          </Layout>
          </div>
          </Router>
        );
      }
}

export default Back;


// WEBPACK FOOTER //
// ./src/components/Back.js